import React from "react";
import styled from "styled-components";

import { Label, LabelText } from "../inputs/Label";

import Switch from "./Switch";

const StyledLabel = styled(Label)`
  align-items: center;
  padding: 0.6rem;
  user-select: none; /* Standard syntax */

  // we want the switch to be the first thing in the label
  & > ${LabelText} {
    order: 1;
  }
`;

const TrailingAdornment = styled.div`
  display: contents;

  & > * {
    order: 2;
  }
`;

export interface Props {
  disabled?: boolean;
  checked?: boolean;
  label: string;
  title?: string;
  width?: number;
  onClick?: () => void;
  trailingAdornment?: React.ReactNode;
}

const SwitchButton: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <StyledLabel label={props.title ?? props.label} layout="row" disableGrow>
      <Switch
        disabled={props.disabled}
        checked={props.checked}
        onChange={() => {
          props.onClick?.();
        }}
      />
      {props.trailingAdornment && (
        <TrailingAdornment>{props.trailingAdornment}</TrailingAdornment>
      )}
    </StyledLabel>
  );
};

export default SwitchButton;
